import { render } from "./SliderCaptcha.vue?vue&type=template&id=ae3aef9e&scoped=true"
import script from "./SliderCaptcha.vue?vue&type=script&lang=js"
export * from "./SliderCaptcha.vue?vue&type=script&lang=js"

import "./SliderCaptcha.vue?vue&type=style&index=0&id=ae3aef9e&scoped=true&lang=less"

import exportComponent from "C:\\IdeaProjects\\frontEnd\\gdstiweb\\node_modules\\.pnpm\\registry.npmmirror.com+vue-loader@16.8.3_@vue+compiler-sfc@3.5.13_vue@3.5.13_webpack@4.47.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae3aef9e"]])

export default __exports__